
import routes from "../../../../../../../../utils/routes";
import {Main} from "../../../../components/Main";
import H2Header from "../../../../components/H2Header";

import {EpisodesPager} from "../../../../../../../../components/List/Podcast/EpisodesPager";
import {OrderBy} from "../OrderBy";
import MainEpisode from "./mainEpisode";
import {GetApiPodcastEpisodesOrderByEnum} from "../../../../../../../../generated";
import {useRadio} from "../../../../../../../../contexts/useRadio";
import {useParams, useSearchParams} from "react-router-dom";
import {useIsLoggedUser} from "../../../../../../../../utils/UseIsLoggedUser";
import {useSuspenseQueries} from "@tanstack/react-query";
import {useProgramKey} from "../../../../../../../../queriesKeys/useProgramKey";
import {useProgramEpisodesKey} from "../../../../../../../../queriesKeys/useProgramEpisodesKey";
import {useProgramEpisodeKey} from "../../../../../../../../queriesKeys/useProgramEpisodeKey";


export default function RadioPodcastyEpisode() {

    const radio = useRadio()!;
    const { slugProgram , episodeId: episodeIdSlug } = useParams();
    const [params] = useSearchParams();
    const page = parseInt(params.get("page") || '') || 1;
    const id = parseInt(episodeIdSlug!.split("-")[0]);

    let orderBy = params.get("orderBy") as GetApiPodcastEpisodesOrderByEnum || GetApiPodcastEpisodesOrderByEnum.PubDate
    const isLogged = useIsLoggedUser();
    if (typeof window === "undefined"
        || !isLogged
        || ![GetApiPodcastEpisodesOrderByEnum.PubDate, GetApiPodcastEpisodesOrderByEnum.Listened].includes(orderBy))
        orderBy = GetApiPodcastEpisodesOrderByEnum.PubDate;

    const [
        { data: program},
        {data: episodes},
        { data: episode},
    ] = useSuspenseQueries({
        queries: [
            useProgramKey(slugProgram!),
            useProgramEpisodesKey(page, slugProgram!, orderBy),
            useProgramEpisodeKey(id, slugProgram!)
        ]
    })


    return <>
        <Main id={"episodes"} radio={radio} activeUrl={routes.radio_program(radio.slug)}>
                <OrderBy radioSlug={radio.slug} programSlug={program.slug} orderBy={"none"} />
                <MainEpisode episode={episode} episodeId={id} program={program} />
                <hr className={"mt-36px mb-36px"}/>
                <H2Header>{program.name}</H2Header>
                <EpisodesPager episodes={episodes} program={program} page={page} orderBy={orderBy} />
        </Main>
    </>
}